import { Abwesenheit } from './Abwesenheit';
import { Arbeitszeit } from './Arbeitszeit';
import { BaseRow } from './BaseRow';
import { RowTypeMap } from './Entities';

export class Konflikt extends BaseRow {
  readonly _type: keyof RowTypeMap = 'konflikt';
  readonly rootArbeitszeit: Arbeitszeit;
  readonly conflictCause: Abwesenheit | Arbeitszeit | null;

  constructor({
    arbeitszeit,
    conflictCause,
  }: {
    arbeitszeit: Arbeitszeit;
    conflictCause: Abwesenheit | Arbeitszeit | null;
  }) {
    super();
    this.rootArbeitszeit = arbeitszeit;
    this.conflictCause = conflictCause;
  }
}
